export default __webpack_public_path__ + "static/media/bit.96a73910.svg";